import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view component
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Represents the tableInformeGerencialView class.
 * Extends the JetView class to create a specific view for the application.
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        /**
         * Formats a given value as a percentage string.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%';
        }
        // Extend the default summColumn filter to create a summTreeColumn filter
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the display of the summary for a tree column.
                 * @param {Object} master - The master data view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    // Iterate through each data object in the master view
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'GgrPorc') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    // Update the inner HTML of the node with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            webix.ui.datafilter.summColumn, // Extend from summColumn
        );
        return {
            rows: [
                {
                    id: 'preloader', // Identifier for the preloader row
                    cols: [
                        {
                            view: 'treetable', // Define a tree table view
                            id: 'AgentInform', // Identifier for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                $group: {
                                    by: 'User', // Grouping by User
                                    footer: {
                                        Pais: ['', 'string'], // Footer configuration for Pais
                                        User: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                                        CantidadTickets: ['CantidadTickets', 'sum'],
                                        Stake: ['Stake', 'sum'],
                                        StakePromedio: ['StakePromedio', 'sum'],
                                        Payout: ['Payout', 'sum'],
                                        Bonos: ['Bonos', 'sum'],
                                        Ggr: ['Ggr', 'sum'],
                                        GgrPorc: ['GgrPorc', 'sum'],
                                        css: { background: 'black' }, // Custom CSS for footer
                                    },
                                    map: {
                                        Pais: ['Pais'], // Mapping for Pais
                                        CantidadTickets: ['CantidadTickets', 'sum'],
                                        Stake: ['Stake', 'sum'],
                                        StakePromedio: ['StakePromedio', 'sum'],
                                        Payout: ['Payout', 'sum'],
                                        Bonos: ['Bonos', 'sum'],
                                        Ggr: ['Ggr', 'sum'],
                                        GgrPorc: [
                                            'GgrPorc',
                                            /**
                                             * Calculates the GGR percentage based on Stake and Ggr values.
                                             * @param {string} prop - The property name.
                                             * @param {Array} data - The array of data objects.
                                             * @returns {number} The calculated GGR percentage.
                                             */
                                            function (prop, data) {
                                                if (!data.length) return 0; // Return 0 if no data
                                                var summ1 = 0; // Initialize sum for Stake
                                                var summ2 = 0; // Initialize sum for Ggr
                                                // Iterate through data to calculate sums
                                                for (var i = data.length - 1; i >= 0; i--) {
                                                    console.log(data[i]); // Log each data object
                                                    summ1 = summ1 + Math.floor(data[i].Stake); // Sum Stake values
                                                    summ2 = summ2 + Math.floor(data[i].Ggr); // Sum Ggr values
                                                }
                                                console.log(summ1); // Log total Stake
                                                console.log(summ2); // Log total Ggr
                                                return (summ2 / summ1) * 100; // Calculate and return GGR percentage
                                            },
                                        ],
                                    },
                                },
                            },
                            bready: function () {
                                this.openAll(); // Open all rows by default
                            },
                            columns: [
                                {
                                    id: 'Pais', // Column identifier for Pais
                                    header: _('País'), // Header label for Pais
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 250, // Column width
                                    /**
                                     * Template function to display the Pais value.
                                     * @param {Object} obj - The data object.
                                     * @param {Object} common - Common utilities for rendering.
                                     * @returns {string} The rendered template string.
                                     */
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Render group header
                                            );
                                        return obj.Pais; // Render Pais value
                                    },
                                },
                                {
                                    id: 'User', // Column identifier for User
                                    header: _('Usuario'), // Header label for User
                                    width: 150, // Column width
                                },
                                { id: 'Date', header: _('Fecha'), width: 150 }, // Column for Date
                                {
                                    id: 'Moneda', // Column identifier for Moneda
                                    header: _('Moneda'), // Header label for Moneda
                                    width: 150, // Column width
                                },
                                {
                                    id: 'CantidadTickets', // Column identifier for CantidadTickets
                                    header: _('Cantidad Tickets'), // Header label for Cantidad Tickets
                                    format: webix.i18n.intFormat, // Formatting function for integer values
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Stake', // Column identifier for Stake
                                    header: _('Stake'), // Header label for Stake
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'StakePromedio', // Column identifier for StakePromedio
                                    header: _('Stake Promedio'), // Header label for Stake Promedio
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Payout', // Column identifier for Payout
                                    header: _('Payout'), // Header label for Payout
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Bonos', // Column identifier for Bonos
                                    header: _('Bonos'), // Header label for Bonos
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Ggr', // Column identifier for GGR
                                    header: _('GGR'), // Header label for GGR
                                    format: webix.i18n.priceFormat, // Formatting function for price values
                                    exportType: 'number', // Export type for this column
                                    width: 200, // Column width
                                },
                                {
                                    id: 'GgrPorc', // Column identifier for GGR percentage
                                    header: _('GGR %'), // Header label for GGR percentage
                                    format: percentFormat, // Formatting function for percentage values
                                    width: 200, // Column width
                                },
                            ],
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Set load ahead value
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch default data
                            pager: 'pagerA', // Identifier for the pager
                            leftSplit: 2, // Number of columns to split on the left
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component for displaying agent information
        grid = $$('AgentInform');

        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);

        // Construct the API URL for fetching management report data
        var url = devConfig.geturlApi() + 'es/Agents/GetInformeGerencial?FromId=' + cur_user + '&';

        // Initialize an empty filter string
        var filter = '';

        // Attach an event handler for when the grid has finished loading data
        grid.attachEvent('onAfterLoad', function () {
            // Display a message indicating that data has been loaded
            webix.message('Data loaded');

            // Group the grid data by 'Pais' (Country) and set up footer calculations
            $$('AgentInform').data.group({
                by: 'Pais',
                footer: {
                    Pais: ["<span style='font-weight:bold;'>Total:</span>", 'string'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    Stake: ['Stake', 'sum'],
                    StakePromedio: ['StakePromedio', 'sum'],
                    Payout: ['Payout', 'sum'],
                    Bonos: ['Bonos', 'sum'],
                    Ggr: ['Ggr', 'sum'],
                    GgrPorc: ['GgrPorc', 'sum'],
                    css: { background: 'black' }, // Set footer background color
                },
                map: {
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    Stake: ['Stake', 'sum'],
                    StakePromedio: ['StakePromedio', 'sum'],
                    Payout: ['Payout', 'sum'],
                    Bonos: ['Bonos', 'sum'],
                    Ggr: ['Ggr', 'sum'],
                    GgrPorc: ['GgrPorc', 'sum'],
                },
            });
        });

        // Listen for filter events from the application
        this.on(this.app, 'managementReport:filter', (filterData) => {
            // Convert filter data object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';

            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filter
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle other filters, excluding 'Date'
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            // Handle single date filter
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle nested object filters
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            // Check for non-null values in the nested object
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;

            // Clear the grid data before loading new data
            grid.clearAll();
            // Load the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });

        // Attach an event handler for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Reload the grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Attach an event handler for item clicks in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Retrieve the clicked item from the grid
            var item = this.getItem(id);
            // Trigger an event with the selected user's ID
            this.$scope.app.callEvent('user:id', [item.Id]);
        });

        // Listen for player selection events from the application
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player ID
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
